/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MetricsBatch } from '../models/MetricsBatch';
import type { TrackEvent } from '../models/TrackEvent';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AnalyticsService {
    /**
     * Track Event
     * Track an event from the widget (public endpoint)
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static trackEventApiV1AnalyticsTrackPost(
        requestBody: TrackEvent,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/analytics/track',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Post Frontend Metrics
     * Post performance metrics from the frontend
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postFrontendMetricsApiV1AnalyticsMetricsPost(
        requestBody: MetricsBatch,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/analytics/metrics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Analytics Stats
     * Get general analytics stats for a project
     * @param projectId
     * @param days
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getAnalyticsStatsApiV1AnalyticsStatsGet(
        projectId: number,
        days: number = 30,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/analytics/stats',
            query: {
                'days': days,
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Realtime Stats
     * Get real-time stats for a project
     * @param projectId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getRealtimeStatsApiV1AnalyticsRealtimeStatsGet(
        projectId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/analytics/realtime-stats',
            query: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Peak Hours
     * Get peak activity hours for a project
     * @param projectId
     * @param days
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getPeakHoursApiV1AnalyticsPeakHoursGet(
        projectId: number,
        days: number = 30,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/analytics/peak-hours',
            query: {
                'days': days,
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Funnel
     * Get the conversion funnel for the entire platform
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getFunnelApiV1AnalyticsFunnelGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/analytics/funnel',
        });
    }
    /**
     * Export Csv
     * Export analytics data to CSV
     * @param projectId
     * @param days
     * @returns any Successful Response
     * @throws ApiError
     */
    public static exportCsvApiV1AnalyticsExportCsvGet(
        projectId: number,
        days: number = 30,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/analytics/export.csv',
            query: {
                'days': days,
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Track Event
     * Track an event from the widget (public endpoint)
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static trackEventApiV1SignalsTrackPost(
        requestBody: TrackEvent,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/signals/track',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Post Frontend Metrics
     * Post performance metrics from the frontend
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postFrontendMetricsApiV1SignalsMetricsPost(
        requestBody: MetricsBatch,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/signals/metrics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Analytics Stats
     * Get general analytics stats for a project
     * @param projectId
     * @param days
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getAnalyticsStatsApiV1SignalsStatsGet(
        projectId: number,
        days: number = 30,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/signals/stats',
            query: {
                'days': days,
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Realtime Stats
     * Get real-time stats for a project
     * @param projectId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getRealtimeStatsApiV1SignalsRealtimeStatsGet(
        projectId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/signals/realtime-stats',
            query: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Peak Hours
     * Get peak activity hours for a project
     * @param projectId
     * @param days
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getPeakHoursApiV1SignalsPeakHoursGet(
        projectId: number,
        days: number = 30,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/signals/peak-hours',
            query: {
                'days': days,
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Funnel
     * Get the conversion funnel for the entire platform
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getFunnelApiV1SignalsFunnelGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/signals/funnel',
        });
    }
    /**
     * Export Csv
     * Export analytics data to CSV
     * @param projectId
     * @param days
     * @returns any Successful Response
     * @throws ApiError
     */
    public static exportCsvApiV1SignalsExportCsvGet(
        projectId: number,
        days: number = 30,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/signals/export.csv',
            query: {
                'days': days,
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
